import AccordionCustom from "@components/Accordion/AccordionCustom";
import ImageGrid from "@components/ImageGrid";
import { CardDataDetailsProps } from "@components/LandingPageComponents/CardDataDetails";
import FeatureCardSection from "@components/LandingPageComponents/CardSection";
import OdooHeader from "@components/LandingPageComponents/OdooHeader";
import TestimonialSection from "@components/LandingPageComponents/TestimonialSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import NewLayout from "@components/new-ui/Layout";
import YellowCTAhref from "@components/yellowCTAhref";
import dynamic from "next/dynamic";
import Head from "next/head";
import goireland from "public/goireland.png";
import React from "react";

const cardDataCollection: CardDataDetailsProps[] = [
    {
        img: "https://assets.gallabox.com/gb-home/calendly/card-1.png",
        title: "Immediate Booking Confirmation",
        description: "As soon as a booking is made, the attendee receives instantaneous confirmation, reinforcing their decision to attend.",
    },
    {
        img: "https://assets.gallabox.com/gb-home/calendly/card-2.png",
        title: "Minimising Non-Attendance",
        description: "Using WhatsApp to deliver event reminders and drastically reduce no-shows, offering a personalised approach to customary emails.",
    },
    {
        img: "https://assets.gallabox.com/gb-home/calendly/card-3.png",
        title: "Enhancing Engagement",
        description: "Hassle-FCollect timely feedback from event attendees through WhatsApp messages and see the difference in open and read rates to emailsree Event Management",
    },
    {
        img: "https://assets.gallabox.com/gb-home/calendly/card-4.png",
        title: "Hassle-Free Event Management",
        description: "With WhatsApp Business API, you can manage events of any volume with ease, automating confirmations and communication ",
    },
];

const CardDataCarousal = dynamic(() => import("@components/LandingPageComponents/CardDataCarousal"), {
    ssr: false,
});

const faqPageSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
        {
            "@type": "Question",
            name: " Is it possible to connect Calendly with WhatsApp Business API?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Certainly, it's possible to connect Calendly with WhatsApp. This can be achieved through third-party tools such as Zapier, or WhatsApp Automation platforms like Gallabox, enabling automated communications once an event has been arranged in Calendly.",
            },
        },
        {
            "@type": "Question",
            name: "What does a WhatsApp and Calendly integration offer? ",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Joining forces, Calendly and WhatsApp bring the convenience of instantaneous confirmation messages straight to your WhatsApp inbox when an appointment is booked via Calendly. This not only gives the scheduler reassurance but also enhances your professional image before your customers, prospects, investors, and other stakeholders.",
            },
        },
        {
            "@type": "Question",
            name: "Does this integration permit sending messages to overseas phone numbers?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Yes, it's possible to send confirmation messages internationally, given that you adhere to WhatsApp’s business communication guidelines and the recipient provides their consent.",
            },
        },
        {
            "@type": "Question",
            name: "Why is Gallabox the best platform to integration WhatsApp Business API with Calendly?",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Gallabox is the ultimate platform for connecting WhatsApp and Calendly due to its seamless interface, intelligent bots, and a hoard of ready-to-use templates. It enhances communication efficiency, ensuring everyone stays notified and engaged - optimising the scheduling process once and for all.",
            },
        },
        {
            "@type": "Question",
            name: "Is this integration safe to use? ",
            acceptedAnswer: {
                "@type": "Answer",
                text: "Rest assured, all platforms involved in this integration - Calendly and Gallabox - place a high priority on user security. Nonetheless, it's always a good idea to avoid sharing sensitive information and keep your API tokens and keys strictly confidential.",
            },
        },
    ],
};

const calendly: React.FC = () => {
    return (
        <NewLayout
            title="Calendly WhatsApp Integration for Scheduling | Gallabox"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/calendly/og-calendly.png" }}
            canonical="https://gallabox.com/whatsapp-integrations/calendly"
            description="Automate appointment reminders via Calendly WhatsApp integration by Gallabox. Reduce no-shows and improve scheduling."
        >
            <Head>
                <script type="application/ld+json">{JSON.stringify(faqPageSchema)}</script>
            </Head>
            <div className="bg-white">
                <OdooHeader
                    pageTitle="WhatsApp Calendly Integration"
                    mainTitle="Calendly WhatsApp Integration for Smooth Appointment Scheduling"
                    description="Integrating Calendly and WhatsApp makes your interactions more professional and reassures your clients about their scheduled appointments."
                    buttonText="Sign up for free"
                    imageUrl="https://assets.gallabox.com/gb-home/calendly/header-new.png"
                />

                <div className="lg:max-w-7xl mx-auto">
                    <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                    <ClientLogos />
                </div>

                <CardDataCarousal cardDataCollection={cardDataCollection} />
                <FeatureCardSection
                    imageURl="https://assets.gallabox.com/gb-home/calendly/s1.png"
                    title="Send Booking Confirmations via WhatsApp Instantly"
                    description="Having this kind of instant confirmation not only makes your contacts feel respected and valued but it also reduces the chances of no-shows. A simple, automated confirmation message can do wonders in establishing a firm rapport with your existing and potential customers."
                    isImageRightSide
                />

                <FeatureCardSection
                    imageURl="https://assets.gallabox.com/gb-home/calendly/s2.png"
                    title="Say Goodbye to No Shows with Automated Event Reminders "
                    description="Most SMBs are all too familiar with the struggle to keep their contacts engaged and informed. Even with invites and confirmation emails, important reminders can get lost in the shuffle. WhatsApp automation steps in here, turning this challenge into a streamlined, efficient process."
                />
                <FeatureCardSection
                    imageURl="https://assets.gallabox.com/gb-home/calendly/s3.png"
                    title="Boost Your Engagement Rates with Timely Follow-Up"
                    description="Collect instant feedback or follow up in a timely manner to request and collate feedback. Implement the feedback into your event management processes, follow up with them, and stay in touch, informing them of your upcoming events and encouraging people to return for more."
                    isImageRightSide
                />

                <FeatureCardSection
                    imageURl="https://assets.gallabox.com/gb-home/calendly/s4.png"
                    title="Avoid Scheduling Nightmares with the WhatsApp Calendly Integration"
                    description="Is the process of managing your appointments and sending reminders across different platforms overwhelming? Integrate your Calendly account with your WhatsApp Business API today, save yourselves from the hassle of manual efforts and make your scheduling process more efficient. "
                />

                <YellowCTAhref
                    buttonText="Get Started Today"
                    customText={
                        <h3 className="text-2xl md:text-3xl font-bold text-yellow-800">
                            Connect Calendly and WhatsApp Business API for <br /> Streamlined Appointment Management and Reminders!
                        </h3>
                    }
                />

                <TestimonialSection
                    TestimonialSectionPropsData={[
                        {
                            companyImg: goireland,
                            headerTitle: "Gallabox’s WhatsApp Widget reduced FTR  from 15-30 minutes to less than a minute, boosting engagement and conversion rates.",
                            avatarImg: "https://assets.gallabox.com/gb-home/go-ireland/goireland-owner.png",
                            nameText: "Ilaya Bharathi",
                            professionText: "Founder & CEO, GoIreland",
                        },
                    ]}
                />

                <ImageGrid />

                <section className="max-w-6xl py-4 mx-auto px-4">
                    <div className="flex flex-col justify-center lg:gap-4 gap-2 items-center pb-6">
                        <p className="lg:text-4xl text-3xl text-center font-bold text-gray-700">Frequently asked questions</p>
                        <h3 className="text-gray-500 text-center lg:text-2xl text-lg font-normal ">Everything you need to know about Calendly-Gallabox integration</h3>
                    </div>
                    <AccordionCustom
                        title="Calendly-Gallabox integration"
                        items={[
                            {
                                question: " Is it possible to connect Calendly with WhatsApp Business API?",
                                answer: "Certainly, it's possible to connect Calendly with WhatsApp. This can be achieved through third-party tools such as Zapier, or WhatsApp Automation platforms like Gallabox, enabling automated communications once an event has been arranged in Calendly.",
                            },
                            {
                                question: "What does a WhatsApp and Calendly integration offer? ",
                                answer: "Joining forces, Calendly and WhatsApp bring the convenience of instantaneous confirmation messages straight to your WhatsApp inbox when an appointment is booked via Calendly. This not only gives the scheduler reassurance but also enhances your professional image before your customers, prospects, investors, and other stakeholders.",
                            },
                            {
                                question: "Does this integration permit sending messages to overseas phone numbers?",
                                answer: "Yes, it's possible to send confirmation messages internationally, given that you adhere to WhatsApp’s business communication guidelines and the recipient provides their consent.",
                            },
                            {
                                question: "Why is Gallabox the best platform to integration WhatsApp Business API with Calendly?",
                                answer: "Gallabox is the ultimate platform for connecting WhatsApp and Calendly due to its seamless interface, intelligent bots, and a hoard of ready-to-use templates. It enhances communication efficiency, ensuring everyone stays notified and engaged - optimising the scheduling process once and for all.",
                            },
                            {
                                question: "Is this integration safe to use? ",
                                answer: "Rest assured, all platforms involved in this integration - Calendly and Gallabox - place a high priority on user security. Nonetheless, it's always a good idea to avoid sharing sensitive information and keep your API tokens and keys strictly confidential.",
                            },
                        ]}
                    />
                </section>
            </div>
        </NewLayout>
    );
};

export default calendly;
